import { PropsWithChildren } from "react";
import ClientAdSettings from "@components/Advertisement/components/ClientAdSettings/ClientAdSettings";
import MyBTFollowedKeywords from "@features/mybt/components/MyBTFollowedKeywords";
import { AuthDetails } from "@features/mySph/AuthDetails";
import RefreshAuthWithRedirect from "@features/mySph/RefreshAuthWithRedirect";
import { PostHogProvider } from "@features/posthog/hooks/usePosthogProvider";
import useIsAppWebView from "@hooks/useIsAppWebView";
import { LightboxProvider } from "@sphtech/idpf-lightbox-react";
import { NeuronProvider } from "@sphtech/neuron";
import { StickyAudioPlayerProvider } from "@sphtech/web2-sticky-audio-player";
import { IS_PLAYWRIGHT, ROUTES_TO_EXCLUDE_COMMON_FOOTER } from "@util/constant";
import { neuronConfig } from "@util/neuron/constants";
import NeuronImplementation from "@util/neuron/NeuronImplementation";

import Footer from "./components/Footer/Footer";
import IdleTimer from "./components/IdleTimer/IdleTimer";

type ProvidersRootProps = {
  pathname: string;
  isWithAuth: boolean;
} & PropsWithChildren;

const ProvidersRoot = ({
  pathname,
  isWithAuth,
  children,
}: ProvidersRootProps): React.ReactElement => {
  const isAppWebView = useIsAppWebView();

  if (IS_PLAYWRIGHT) {
    return (
      <StickyAudioPlayerProvider>
        <LightboxProvider>
          <IdleTimer />

          {children}

          {!ROUTES_TO_EXCLUDE_COMMON_FOOTER.includes(pathname) &&
          !pathname.startsWith("/pulse") &&
          !isAppWebView ? (
            <Footer />
          ) : null}
        </LightboxProvider>
      </StickyAudioPlayerProvider>
    );
  }

  if (!isWithAuth) {
    return (
      <StickyAudioPlayerProvider>
        <IdleTimer />

        {children}
      </StickyAudioPlayerProvider>
    );
  }

  return (
    <StickyAudioPlayerProvider>
      <LightboxProvider>
        <NeuronProvider config={neuronConfig}>
          <NeuronImplementation />

          <PostHogProvider>
            <IdleTimer />

            <MyBTFollowedKeywords />
            <ClientAdSettings />
            <RefreshAuthWithRedirect />
            <AuthDetails />

            {children}

            {!ROUTES_TO_EXCLUDE_COMMON_FOOTER.includes(pathname) &&
            !pathname.startsWith("/pulse") &&
            !isAppWebView ? (
              <Footer />
            ) : null}
          </PostHogProvider>
        </NeuronProvider>
      </LightboxProvider>
    </StickyAudioPlayerProvider>
  );
};

export default ProvidersRoot;
